import { useEffect, useMemo, useState } from "react";
import useIsMobile from "../../../../../hooks/device/useIsMobile.js";
import useValue from "../../../../../hooks/forms/useValue.js";
const getVisibleSearcher = (selectedItem)=>({
        [selectedItem?.searcher?.name]: selectedItem
    });
const useSearcherMultiPakView = (rootProps)=>{
    const props = 'data' in rootProps ? rootProps.data : rootProps.props;
    const { items  } = props ?? {};
    const productValue = useValue({
        name: 'product'
    });
    const selectedItem = useMemo(()=>items?.find((item)=>item.radio?.value === productValue), [
        items,
        productValue
    ]);
    const initialVisibleSearchers = useMemo(()=>getVisibleSearcher(selectedItem), [
        selectedItem
    ]);
    const [visibleSearchers, setVisibleSearchers] = useState(initialVisibleSearchers);
    useEffect(()=>{
        if (selectedItem?.searcher?.name && !Object.keys(visibleSearchers).includes(selectedItem?.searcher?.name)) {
            setVisibleSearchers((prevVisibleSearchers)=>({
                    ...prevVisibleSearchers,
                    ...getVisibleSearcher(selectedItem)
                }));
        }
    }, [
        selectedItem,
        visibleSearchers
    ]);
    const isMobile = useIsMobile();
    const productInput = useMemo(()=>({
            name: 'product',
            options: items?.filter((item)=>!!item.radio)?.map((item)=>item.radio) ?? [],
            radioVariant: isMobile ? 'button' : 'default'
        }), [
        isMobile,
        items
    ]);
    const inputs = useMemo(()=>({
            product: productInput
        }), [
        productInput
    ]);
    return {
        inputs,
        visibleSearchers,
        productValue
    };
};
export default useSearcherMultiPakView;

//# sourceMappingURL=useSearcherMultiPakView.js.map